import * as React from 'react';
export const grabpaySvg = React.forwardRef(function grabpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00B14F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.773 5c2.256 0 3.883.249 5.245.801l.13.055V7.74c-1.333-.807-2.993-1.169-5.375-1.169a10 10 0 0 0-6.861 2.72c-1.792 1.682-2.837 3.943-2.881 6.222l-.002.152v.543c0 2.468.918 4.76 2.585 6.455 1.676 1.703 3.948 2.638 6.403 2.638 3.707 0 5.626-1.314 6.457-2.128l.04-.039.006-.006V16.29h-6.91v-1.68h8.59v9.04l-.076.1c-.21.264-.845.977-2.03 1.683-1.725 1.026-3.769 1.548-6.076 1.548-2.87 0-5.554-1.108-7.556-3.124-1.966-1.98-3.066-4.63-3.11-7.475v-.717C5.35 9.885 10.58 5 16.772 5Zm0 2.808c2.127 0 3.748.34 5.228 1.101l.147.078v1.985c-1.302-1.07-2.816-1.484-5.375-1.484-3.661 0-6.76 2.769-6.826 6.07l-.001.107v.543c0 1.671.629 3.231 1.775 4.39a5.991 5.991 0 0 0 4.296 1.788c1.705 0 2.75-.302 3.359-.525l.322-.125.014-.004v-2.527H15.61v-1.678h5.675v5.041l-.038.036c-.417.394-1.861 1.462-5.23 1.462-4.23 0-7.68-3.455-7.748-7.729l-.001-.13v-.542c0-2.077.894-4.046 2.516-5.543a8.812 8.812 0 0 1 5.99-2.314Z',
      fill: '#fff',
    }),
  );
});
grabpaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var grabpay = {
  category: 'brand',
  colorable: false,
  name: 'grabpay',
  svg: grabpaySvg,
};
